import InnerComponent from '../../../components/Inventory/ManageProducts/ViewProduct/ProductBOMList/ProductBOM';
import orgContainer from '@Components/AppContainer';

const ViewBOM = () => ((orgContainer(InnerComponent)));
export default ViewBOM;